<template>
    <div>
        <div class="columns" v-if="category !== null">
            <div class="column is-6">
                <category-form :category="category" @saved="reloadCategory"></category-form>
            </div>
            <div class="column is-6">
                <h2 class="subtitle">Products in this category</h2>
                <div v-for="product in linkedProducts">
                    <router-link :to="{ name: 'product', params: {id: product.id}}">
                        {{ product.name }}
                    </router-link>
                </div>
                <br/>
                <a>Add product to category...</a>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex"
    export default {
        data() {
            return {
                category_id: parseInt(this.$route.params.id),
                category: null,
            }
        },
        computed: Object.assign({}, mapGetters(['categories', 'products']), {
            linkedProducts() {
                let links = this.$store.state.products.product_categories.filter(item => item.category_id === this.category_id)
                let ids   = []
                for (let link in links) {
                    ids.push(links[link].product_id)
                }

                return this.products.filter(product => ids.indexOf(product.id) !== -1)
            },
        }),
        mounted() {
            this.reloadCategory();
        },
        methods: {
            changeCategory(newId, oldId) {
                this.category_id = parseInt(newId)
                this.reloadCategory()
            },
            reloadCategory() {
                this.category = null;
                setTimeout(() => {
                    this.category = this.categories.find(category => category.id === this.category_id)
                })
            }
        },
        watch: {
            '$route.params.id': 'changeCategory'
        }
    };
</script>



// WEBPACK FOOTER //
// CategoryEdit.vue?6867bb41